import { api } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { MonthlyTransactionsParams, MonthlyTransactionsResponse } from "@/interface/settlement/monthlyTransactions/index";

export const useMonthlyTransactions = (params: MonthlyTransactionsParams) => {
    const { startYear, startMonth, endYear, endMonth, searchType, search, exactMatch, company, page = 0, size = 20 } = params;

    return useQuery<MonthlyTransactionsResponse>({
        queryKey: ["monthlyTransactions", params],
        queryFn: async () => {
            const response = await api.get("/monthly-transactions", {
                params: {
                    startYear,
                    startMonth,
                    endYear,
                    endMonth,
                    searchType,
                    search,
                    exactMatch,
                    company,
                    page,
                    size,
                },
            });
            return response.data;
        },
        gcTime: 0,
        refetchOnMount: true,
    });
};
